import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BulkImportResult } from '../components/bulk-import/bulk-import-result';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class BulkImportService {
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private _authservice: AuthService) { }

  downloadTemplate(): Observable<Blob> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl + 'bulkImport/downloadTemplate', { headers, responseType: 'blob' });
  }

  importCoursesAndMaterials(file: File): Observable<BulkImportResult> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<BulkImportResult>(this.apiUrl + 'bulkImport/importCoursesAndMaterials', formData, { headers });
  }
}
